if (!customElements.get("block-cross-sell")) {
  class BlockCrossSell extends Element {
    props = {
      mainProduct: {},
      mainProductVariant: {},
      mainProductVariants: [],
      crossSellProduct: {},
      crossSellProductVariants: [],
      description: "",
      showDrawer: true,
      quantityLabel: "Qty",
      crossSellTotal: 0,
      crossSellIndex: 0,
      quantity: 1,
      status: "idle",
      currentMainProductVariant: {},
      currentCrossSellProductVariant: {},
    };

    setup(props) {
      this.data.currentMainProductVariant = props.mainProductVariant;
      this.data.currentCrossSellProductVariant = this.getMatchedVariantSize(props.mainProductVariant);
    }

    setupListeners() {
      ProductPageStore.subscribe((event) => {
        this.handleMainProductVariantChange(event.detail.currentVariant);
      });

      this.addEventListener("cross-sell:add", () => {
        this.data.status = "active";
        this.notifyStateChange();
      });

      this.addEventListener("cross-sell:remove", () => {
        this.data.status = "idle";
        this.data.quantity = 1;
        this.notifyStateChange();
      });

      this.addEventListener("cross-sell:quantity-change", (event) => {
        this.data.quantity = event.detail.quantity;
        this.notifyStateChange();
      });

      this.addEventListener("cross-sell:drawer-open", () => {
        this.handleCrossSellDrawerOpen();
      });
    }

    getMatchedVariantSize(mainProductVariant) {
      if (!this.props.crossSellProductVariants) return undefined;
      const size = mainProductVariant?.title?.split("(")?.[0]?.trim()?.toLowerCase();
      if (!size) return undefined;
      const regex = new RegExp(String.raw`^${size}$`, "i");
      const matchedVariant = this.props.crossSellProductVariants.find((variant) =>
        regex.test(variant.title.split("(")?.[0]?.trim()?.toLowerCase()),
      );
      return matchedVariant || this.props.crossSellProductVariants[0];
    }

    handleMainProductVariantChange(mainProductVariant) {
      const variant = this.getMatchedVariantSize(mainProductVariant);
      this.data.currentMainProductVariant = mainProductVariant;
      this.data.currentCrossSellProductVariant = variant;
      if (!variant?.available) this.data.status = "idle";
    }

    notifyStateChange() {
      this.dispatchEvent(
        new CustomEvent("update", {
          bubbles: true,
          detail: { ...this.data, crossSellProductId: this.props.crossSellProduct.id },
        }),
      );
    }

    getAddToCartData() {
      return {
        isAdded: this.data.status === "active",
        quantity: Number(this.data.quantity),
        variantId: this.data.currentMainProductVariant?.id,
        crossSellVariantId: this.data.currentCrossSellProductVariant?.id,
        status: this.data.status,
        mainProduct: this.props.mainProduct,
      };
    }

    handleCrossSellDrawerOpen() {
      window.eventBus.publish("cross-sell-drawer:open", {
        title: this.props.crossSellProduct.title,
        drawerDescription: this.shadowRoot?.querySelector("cross-sell-drawer-description")?.innerHTML,
        image: this.props.crossSellProduct.featured_image,
        link: "/products/" + this.props.crossSellProduct.handle,
        primaryButton: {
          text: "제품 보러가기",
          onClick: (state, closeDrawer) => {
            window.open(state.link, "_blank");
            closeDrawer();
          },
        },
        secondaryButton: {
          text: "쇼핑 계속하기",
          onClick: (state, closeDrawer) => closeDrawer(),
        },
      });
    }

    get shouldShowItem() {
      const available = this.data.currentCrossSellProductVariant?.available;
      if (this.props.crossSellTotal <= 1) return true;
      if (available) return true;
      return this.props.crossSellIndex >= this.props.crossSellTotal;
    }

    get variantLabel() {
      const title = this.data.currentCrossSellProductVariant?.title;
      if (!title || title === "Default Title") return "";
      return title + " | ";
    }

    template() {
      if (!this.shouldShowItem) return `<div class="hidden"></div>`;

      const variant = this.data.currentCrossSellProductVariant;
      const available = !!variant?.available;
      const price = currencyFormatter.format(((variant?.price || 0) / 100) * this.data.quantity);
      const compareAtPrice = currencyFormatter.format(((variant?.compare_at_price || 0) / 100) * this.data.quantity);
      const isDiscounted = variant?.compare_at_price > variant?.price;

      return `
        <div class="flex items-center gap-3 py-4">
          <img src="${this.props.crossSellProduct.featured_image}&width=100" width="50" height="50" class="rounded size-[50px] object-cover" alt="${this.props.crossSellProduct.title}">
          <div class="flex-1 min-w-0">
            <p class="font-semibold text-[16px] text-[var(--color-neutral-900)]">${this.props.crossSellProduct.title}</p>
            <p class="text-[14px] text-[var(--color-neutral-800)]">${this.variantLabel}${this.props.quantityLabel}: ${this.data.quantity}</p>
            <div class="flex items-center gap-1">
              <span class="text-[14px] text-[var(--color-neutral-900)]">${price}</span>
              ${isDiscounted ? `<span class="text-[14px] text-[var(--color-neutral-800)] line-through">${compareAtPrice}</span>` : ""}
            </div>
          </div>
          <cross-sell-item-add-button :available="${available}" :status="${this.data.status}"></cross-sell-item-add-button>
        </div>
        <div class="pb-4 border-b border-[var(--color-neutral-200)] flex flex-col gap-2 mt-4">
          <cross-sell-item-quantity class="${this.data.status === "idle" ? "hidden" : ""}" :quantity="${this.data.quantity}" :label="${this.props.quantityLabel}"></cross-sell-item-quantity>
          <p class="text-[14px] text-[var(--color-neutral-800)]">${this.props.description}</p>
          ${
            this.props.showDrawer
              ? `<button type="button" data-action="drawer-open" class="flex items-center gap-1 text-[14px] font-bold underline w-max">
            자세히 알아보기
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.36 7.52661L6.5867 3.75994C6.52472 3.69746 6.45099 3.64786 6.36975 3.61402C6.28851 3.58017 6.20137 3.56274 6.11336 3.56274C6.02535 3.56274 5.93822 3.58017 5.85698 3.61402C5.77574 3.64786 5.702 3.69746 5.64003 3.75994C5.51586 3.88485 5.44617 4.05382 5.44617 4.22994C5.44617 4.40607 5.51586 4.57503 5.64003 4.69994L8.94003 8.03328L5.64003 11.3333C5.51586 11.4582 5.44617 11.6272 5.44617 11.8033C5.44617 11.9794 5.51586 12.1484 5.64003 12.2733C5.70177 12.3363 5.7754 12.3864 5.85665 12.4207C5.9379 12.455 6.02516 12.4729 6.11336 12.4733C6.20157 12.4729 6.28882 12.455 6.37007 12.4207C6.45132 12.3864 6.52495 12.3363 6.5867 12.2733L10.36 8.50661C10.4277 8.44418 10.4817 8.36841 10.5186 8.28408C10.5556 8.19975 10.5747 8.10868 10.5747 8.01661C10.5747 7.92454 10.5556 7.83347 10.5186 7.74914C10.4817 7.66481 10.4277 7.58904 10.36 7.52661Z" fill="var(--color-neutral-900)"></path>
            </svg>
          </button>`
              : ""
          }
        </div>
      `;
    }

    onUpdated() {
      this.querySelector('[data-action="drawer-open"]')?.addEventListener("click", () => {
        this.dispatchEvent(new CustomEvent("cross-sell:drawer-open", { bubbles: true }));
      });
    }
  }
  customElements.define("block-cross-sell", BlockCrossSell);
}

if (!customElements.get("cross-sell-item-add-button")) {
  class CrossSellItemAddButton extends Element {
    props = { available: true, status: "idle" };

    template() {
      const isActive = this.props.status === "active";
      return `
        <button type="button" data-role="add" ${this.props.available ? "" : "disabled"} class="${isActive ? "hidden" : ""} bg-[var(--color-primary-500)] disabled:opacity-50 text-[var(--color-neutral-900)] font-semibold text-[14px] rounded-full h-9 px-4 whitespace-nowrap">
          ${this.props.available ? "함께 구매하기" : "품절"}
        </button>
        <button type="button" data-role="remove" aria-label="Remove" class="${isActive ? "" : "hidden"} bg-[var(--color-neutral-50)] rounded-full h-9 w-9 flex items-center justify-center transform rotate-45">
          <svg width="24" height="24" viewBox="0 0 18 19" class="mx-auto" fill="var(--color-neutral-900)" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.25 9.03369H9.75V4.53369C9.75 4.33478 9.67098 4.14401 9.53033 4.00336C9.38968 3.86271 9.19891 3.78369 9 3.78369C8.80109 3.78369 8.61032 3.86271 8.46967 4.00336C8.32902 4.14401 8.25 4.33478 8.25 4.53369V9.03369H3.75C3.55109 9.03369 3.36032 9.11271 3.21967 9.25336C3.07902 9.39401 3 9.58478 3 9.78369C3 9.9826 3.07902 10.1734 3.21967 10.314C3.36032 10.4547 3.55109 10.5337 3.75 10.5337H8.25V15.0337C8.25 15.2326 8.32902 15.4234 8.46967 15.564C8.61032 15.7047 8.80109 15.7837 9 15.7837C9.19891 15.7837 9.38968 15.7047 9.53033 15.564C9.67098 15.4234 9.75 15.2326 9.75 15.0337V10.5337H14.25C14.4489 10.5337 14.6397 10.4547 14.7803 10.314C14.921 10.1734 15 9.9826 15 9.78369C15 9.58478 14.921 9.39401 14.7803 9.25336C14.6397 9.11271 14.4489 9.03369 14.25 9.03369Z" fill="var(--color-neutral-900)"></path>
          </svg>
        </button>
      `;
    }

    onUpdated() {
      this.querySelector('[data-role="add"]').onclick = () =>
        this.dispatchEvent(new CustomEvent("cross-sell:add", { bubbles: true }));
      this.querySelector('[data-role="remove"]').onclick = () =>
        this.dispatchEvent(new CustomEvent("cross-sell:remove", { bubbles: true }));
    }
  }
  customElements.define("cross-sell-item-add-button", CrossSellItemAddButton);
}

if (!customElements.get("cross-sell-item-quantity")) {
  class CrossSellItemQuantity extends Element {
    props = { quantity: 1, label: "Quantity" };

    template() {
      const isDecrementDisabled = this.props.quantity <= 1;
      return `
        <div class="flex items-center justify-between">
          <p class="text-sm font-semibold">${this.props.label}</p>
          <div class="flex items-center gap-4">
            <button type="button" data-role="decrement" ${isDecrementDisabled ? "disabled" : ""} class="rounded-full w-8 h-8 bg-[var(--color-neutral-50)] disabled:opacity-40 disabled:cursor-not-allowed">
              <svg width="24" height="24" viewBox="0 0 18 19" class="mx-auto" fill="var(--color-neutral-900)" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.25 9.03369H3.75C3.55109 9.03369 3.36032 9.11271 3.21967 9.25336C3.07902 9.39401 3 9.58478 3 9.78369C3 9.9826 3.07902 10.1734 3.21967 10.314C3.36032 10.4547 3.55109 10.5337 3.75 10.5337H14.25C14.4489 10.5337 14.6397 10.4547 14.7803 10.314C14.921 10.1734 15 9.9826 15 9.78369C15 9.58478 14.921 9.39401 14.7803 9.25336C14.6397 9.11271 14.4489 9.03369 14.25 9.03369Z" fill="var(--color-neutral-900)"/>
              </svg>
            </button>
            <input value="${this.props.quantity}" class="pt-0 pl-3 w-12 pr-0 pb-0 text-sm cursor-default border-none bg-transparent text-center" type="number" step="1" min="1" readonly>
            <button type="button" data-role="increment" class="rounded-full w-8 h-8 bg-[var(--color-neutral-50)]">
              <svg width="24" height="24" viewBox="0 0 18 19" class="mx-auto" fill="var(--color-neutral-900)" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.25 9.03369H9.75V4.53369C9.75 4.33478 9.67098 4.14401 9.53033 4.00336C9.38968 3.86271 9.19891 3.78369 9 3.78369C8.80109 3.78369 8.61032 3.86271 8.46967 4.00336C8.32902 4.14401 8.25 4.33478 8.25 4.53369V9.03369H3.75C3.55109 9.03369 3.36032 9.11271 3.21967 9.25336C3.07902 9.39401 3 9.58478 3 9.78369C3 9.9826 3.07902 10.1734 3.21967 10.314C3.36032 10.4547 3.55109 10.5337 3.75 10.5337H8.25V15.0337C8.25 15.2326 8.32902 15.4234 8.46967 15.564C8.61032 15.7047 8.80109 15.7837 9 15.7837C9.19891 15.7837 9.38968 15.7047 9.53033 15.564C9.67098 15.4234 9.75 15.2326 9.75 15.0337V10.5337H14.25C14.4489 10.5337 14.6397 10.4547 14.7803 10.314C14.921 10.1734 15 9.9826 15 9.78369C15 9.58478 14.921 9.39401 14.7803 9.25336C14.6397 9.11271 14.4489 9.03369 14.25 9.03369Z" fill="var(--color-neutral-900)"/>
              </svg>
            </button>
          </div>
        </div>
      `;
    }

    onUpdated() {
      this.querySelector('[data-role="increment"]').onclick = () =>
        this.dispatchEvent(
          new CustomEvent("cross-sell:quantity-change", { bubbles: true, detail: { quantity: this.props.quantity + 1 } }),
        );
      this.querySelector('[data-role="decrement"]').onclick = () =>
        this.dispatchEvent(
          new CustomEvent("cross-sell:quantity-change", {
            bubbles: true,
            detail: { quantity: Math.max(1, this.props.quantity - 1) },
          }),
        );
    }
  }
  customElements.define("cross-sell-item-quantity", CrossSellItemQuantity);
}
